//import { css } from "@emotion/react"

import type React from "react";
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";
import { AddOrUpdateCart } from "../../ShoppingCart/AddOrUpdateCart";

export type ProductBrowserGridItemQtyProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserGridItemQty: React.FC<
	ProductBrowserGridItemQtyProps
> = (props) => {
	return (
		<div className="h-21">
			<AddOrUpdateCart product={props.product} />
		</div>
	);
};
